import Amplify from 'aws-amplify';
import { Provider } from 'react-redux';
import { store } from 'redux/store';
import ReactDOM from 'react-dom';
import { Buffer } from 'buffer';
import EnvironmentBanner from 'components/EnvironmentBanner';
import './reloadOnStaleChunk';
import App from './App';
import awsExports from './aws-exports.js';

window.global ||= window;
global.Buffer = Buffer;

Amplify.configure(awsExports);
ReactDOM.render(
  <Provider store={store}>
    <EnvironmentBanner />
    <App />
  </Provider>,
  document.getElementById('root')
);
